import { PartialType } from '@nestjs/swagger';
import { IsIn, IsOptional, IsString } from 'class-validator';
import { CreateEmpleadoDto } from './create-empleado.dto';

export class UpdateEmpleadoDto extends PartialType(CreateEmpleadoDto) {
  @IsOptional()
  @IsString()
  @IsIn(['ACTIVO', 'INACTIVO', 'LICENCIA', 'SUSPENDIDO', 'EGRESADO'])
  estado?: string;
}
